export default __webpack_public_path__ + "media/images/temporary/mud-run-4-0534f9f321441feadad5c1c64304b102.jpg";